import { render, staticRenderFns } from "./cloudSpatialInfo.vue?vue&type=template&id=2ecd3d92&scoped=true"
import script from "./cloudSpatialInfo.vue?vue&type=script&lang=js"
export * from "./cloudSpatialInfo.vue?vue&type=script&lang=js"
import style0 from "./cloudSpatialInfo.vue?vue&type=style&index=0&id=2ecd3d92&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecd3d92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/c-webhlzfq_workbench-web_en_test/orca-ac-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ecd3d92')) {
      api.createRecord('2ecd3d92', component.options)
    } else {
      api.reload('2ecd3d92', component.options)
    }
    module.hot.accept("./cloudSpatialInfo.vue?vue&type=template&id=2ecd3d92&scoped=true", function () {
      api.rerender('2ecd3d92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cloudSpace/components/cloudSpatialInfo.vue"
export default component.exports